import { useId } from 'react';
import { createPortal } from 'react-dom';
import { X } from 'lucide-react';
import { useDialog } from './useDialog';

const sizes = {
  sm: 'max-w-md',
  md: 'max-w-xl',
  lg: 'max-w-3xl',
};

const Modal = ({ isOpen, onClose, title, children, footer, size = 'md' }) => {
  const panelRef = useDialog(isOpen, onClose);
  const titleId = useId();

  if (!isOpen) return null;

  return createPortal(
    <div className="fixed inset-0 z-[1050] overflow-y-auto p-4 sm:p-8">
      <button
        type="button"
        tabIndex={-1}
        aria-label="Close dialog"
        onClick={onClose}
        className="fixed inset-0 cursor-default bg-black/50 backdrop-blur-[2px]"
      />
      <div
        ref={panelRef}
        role="dialog"
        aria-modal="true"
        aria-labelledby={title ? titleId : undefined}
        tabIndex={-1}
        className={`card relative mx-auto mb-0 w-full shadow-xl outline-none ${sizes[size] ?? sizes.md}`}
      >
        <div className="card-header flex items-center justify-between gap-3">
          <h5 id={titleId}>{title}</h5>
          <button type="button" onClick={onClose} aria-label="Close" className="btn btn-icon btn-link-secondary">
            <X className="w-5 h-5" />
          </button>
        </div>
        <div className="card-body">{children}</div>
        {footer && <div className="card-footer flex flex-wrap items-center justify-end gap-2">{footer}</div>}
      </div>
    </div>,
    document.body
  );
};

export default Modal;
